import { sendSpecificStudentQuestionsGeneratedEvent } from '../index';
import { EventAdapter } from './EventAdapter';

type SpecificStudentSelectedQuestionsGeneratedEventAdapterParams =
  SpecificStudentQuestionsGeneratedEvent;

export class SpecificStudentSelectedQuestionsGeneratedAdapter extends EventAdapter {
  protected amplitudeEventFunction = sendSpecificStudentQuestionsGeneratedEvent;
  protected intercomEventKey = null;

  constructor({
    num_areas_of_improvement,
    num_students_selected,
    input_token,
    output_token,
    elapsed_time,
    generation_version,
    generate_explanations,
    num_mc,
    num_tf,
    num_sa,
    total_questions,
  }: SpecificStudentSelectedQuestionsGeneratedEventAdapterParams) {
    super();

    this.eventData = {
      num_areas_of_improvement,
      num_students_selected,
      input_token,
      output_token,
      elapsed_time,
      generation_version,
      generate_explanations,
      num_mc,
      num_tf,
      num_sa,
      total_questions,
    };
  }
}

export type SpecificStudentQuestionsGeneratedEvent = {
  num_areas_of_improvement: number;
  num_students_selected: number;
  input_token: number;
  output_token: number;
  elapsed_time: number;
  generation_version: string;
  generate_explanations: boolean;
  num_mc: number;
  num_tf: number;
  num_sa: number;
  total_questions: number;
};
